var map = {
	"./AllergenAntipreferencesIcon": 33790,
	"./AllergenAntipreferencesIcon.js": 33790,
	"./ArrowDownIcon": 6978,
	"./ArrowDownIcon.js": 6978,
	"./ArrowPath": 95829,
	"./ArrowPath.js": 95829,
	"./ArrowRightIcon": 16879,
	"./ArrowRightIcon.js": 16879,
	"./ArrowToBottomIcon": 51356,
	"./ArrowToBottomIcon.js": 51356,
	"./ArrowsRotateIcon": 24992,
	"./ArrowsRotateIcon.js": 24992,
	"./BinIcon": 15610,
	"./BinIcon.js": 15610,
	"./BoxIcon": 83969,
	"./BoxIcon.js": 83969,
	"./BulletListIcon": 66859,
	"./BulletListIcon.js": 66859,
	"./CalendarIcon": 69912,
	"./CalendarIcon.js": 69912,
	"./CalendarNotOrder": 99342,
	"./CalendarNotOrder.js": 99342,
	"./CashIcon": 7549,
	"./CashIcon.js": 7549,
	"./CheckIcon": 46695,
	"./CheckIcon.js": 46695,
	"./CheckboxCheckedIcon": 52379,
	"./CheckboxCheckedIcon.js": 52379,
	"./CheckboxToCheckIcon": 51122,
	"./CheckboxToCheckIcon.js": 51122,
	"./CheckedCheckbox": 61136,
	"./CheckedCheckbox.js": 61136,
	"./ChevronUpIcon": 94159,
	"./ChevronUpIcon.js": 94159,
	"./CircleInfoIcon": 60203,
	"./CircleInfoIcon.js": 60203,
	"./CirclePauseIcon": 2373,
	"./CirclePauseIcon.js": 2373,
	"./ClientTagAntipreferencesIcon": 14694,
	"./ClientTagAntipreferencesIcon.js": 14694,
	"./ClipboardListIcon": 77265,
	"./ClipboardListIcon.js": 77265,
	"./Clock2Icon": 76779,
	"./Clock2Icon.js": 76779,
	"./ClockIcon": 73751,
	"./ClockIcon.js": 73751,
	"./ContainerIcon": 91974,
	"./ContainerIcon.js": 91974,
	"./CopyIcon": 18950,
	"./CopyIcon.js": 18950,
	"./CopyIconSeccond": 65971,
	"./CopyIconSeccond.js": 65971,
	"./CrownIcon": 99454,
	"./CrownIcon.js": 99454,
	"./DeliveryCarIcon": 84645,
	"./DeliveryCarIcon.js": 84645,
	"./DollarCoinIcon": 18376,
	"./DollarCoinIcon.js": 18376,
	"./EditIcon": 33991,
	"./EditIcon.js": 33991,
	"./EggsIcon": 19335,
	"./EggsIcon.js": 19335,
	"./EllipsisVIcon": 33028,
	"./EllipsisVIcon.js": 33028,
	"./Error404Icon": 62574,
	"./Error404Icon.js": 62574,
	"./ExclamationIcon": 36000,
	"./ExclamationIcon.js": 36000,
	"./ExclamationTriangleIcon": 93671,
	"./ExclamationTriangleIcon.js": 93671,
	"./EyeIcon": 27504,
	"./EyeIcon.js": 27504,
	"./FlameIcon": 90663,
	"./FlameIcon.tsx": 90663,
	"./GoogleIcon": 37185,
	"./GoogleIcon.js": 37185,
	"./HalfStarIcon": 23755,
	"./HalfStarIcon.js": 23755,
	"./HouseIcon": 30961,
	"./HouseIcon.js": 30961,
	"./IconAddOutline": 52774,
	"./IconAddOutline.tsx": 52774,
	"./IconArrowBackOutline": 87663,
	"./IconArrowBackOutline.tsx": 87663,
	"./IconArrowForwardOutline": 79641,
	"./IconArrowForwardOutline.tsx": 79641,
	"./IconAssignmentOutline": 30778,
	"./IconAssignmentOutline.tsx": 30778,
	"./IconAutoRenew": 36268,
	"./IconAutoRenew.tsx": 36268,
	"./IconBlockOutline": 60474,
	"./IconBlockOutline.tsx": 60474,
	"./IconCalendarTodayOutline": 6455,
	"./IconCalendarTodayOutline.tsx": 6455,
	"./IconCardOutline": 31410,
	"./IconCardOutline.tsx": 31410,
	"./IconCheckCircleOutline": 59343,
	"./IconCheckCircleOutline.tsx": 59343,
	"./IconChefHat": 11501,
	"./IconChefHat.tsx": 11501,
	"./IconChevronLeftOutline": 19161,
	"./IconChevronLeftOutline.tsx": 19161,
	"./IconChevronRightOutline": 57094,
	"./IconChevronRightOutline.tsx": 57094,
	"./IconCloseOutline": 78737,
	"./IconCloseOutline.tsx": 78737,
	"./IconCreditCardOutline": 46140,
	"./IconCreditCardOutline.tsx": 46140,
	"./IconDeleteOutline": 37541,
	"./IconDeleteOutline.tsx": 37541,
	"./IconDinnerDiningOutline": 39233,
	"./IconDinnerDiningOutline.tsx": 39233,
	"./IconDraftOutline": 98301,
	"./IconDraftOutline.tsx": 98301,
	"./IconEcoOutline": 34695,
	"./IconEcoOutline.tsx": 34695,
	"./IconEditOutline": 12912,
	"./IconEditOutline.tsx": 12912,
	"./IconErrorOutline": 72860,
	"./IconErrorOutline.tsx": 72860,
	"./IconForkSpoonOutline": 61028,
	"./IconForkSpoonOutline.tsx": 61028,
	"./IconForwardOutline": 76006,
	"./IconForwardOutline.tsx": 76006,
	"./IconGroceryOutline": 84446,
	"./IconGroceryOutline.tsx": 84446,
	"./IconHandMealOutline": 65804,
	"./IconHandMealOutline.tsx": 65804,
	"./IconHistoryOutline": 51779,
	"./IconHistoryOutline.tsx": 51779,
	"./IconInfoOutline": 95388,
	"./IconInfoOutline.tsx": 95388,
	"./IconKeyboardArrowDownOutline": 38302,
	"./IconKeyboardArrowDownOutline.tsx": 38302,
	"./IconKeyboardArrowUpOutline": 79711,
	"./IconKeyboardArrowUpOutline.tsx": 79711,
	"./IconListAltOutline": 6996,
	"./IconListAltOutline.tsx": 6996,
	"./IconLocationOnOutline": 53209,
	"./IconLocationOnOutline.tsx": 53209,
	"./IconLogoutOutline": 24875,
	"./IconLogoutOutline.tsx": 24875,
	"./IconNoMealsOutline": 4409,
	"./IconNoMealsOutline.tsx": 4409,
	"./IconPercentDiscountOutline": 7213,
	"./IconPercentDiscountOutline.tsx": 7213,
	"./IconPersonOutline": 42926,
	"./IconPersonOutline.tsx": 42926,
	"./IconPortionBagOutline": 49307,
	"./IconPortionBagOutline.tsx": 49307,
	"./IconQuantityMinus": 21740,
	"./IconQuantityMinus.tsx": 21740,
	"./IconQuantityPlus": 5292,
	"./IconQuantityPlus.tsx": 5292,
	"./IconRemoveOutline": 90999,
	"./IconRemoveOutline.tsx": 90999,
	"./IconSavingsOutline": 13211,
	"./IconSavingsOutline.tsx": 13211,
	"./IconSettingsOutline": 29408,
	"./IconSettingsOutline.tsx": 29408,
	"./IconShoppingBagOutline": 72334,
	"./IconShoppingBagOutline.tsx": 72334,
	"./IconShoppingCartOutline": 50873,
	"./IconShoppingCartOutline.tsx": 50873,
	"./IconShoppingModeOutline": 15239,
	"./IconShoppingModeOutline.tsx": 15239,
	"./IconSkilletOutline": 5138,
	"./IconSkilletOutline.tsx": 5138,
	"./IconSpeedOutline": 40918,
	"./IconSpeedOutline.tsx": 40918,
	"./IconStarFill": 18506,
	"./IconStarFill.tsx": 18506,
	"./IconStarOutline": 99310,
	"./IconStarOutline.tsx": 99310,
	"./IconStarRating": 13087,
	"./IconStarRating.tsx": 13087,
	"./IconTrendingUpSimple": 90136,
	"./IconTrendingUpSimple.tsx": 90136,
	"./IconWarningOutline": 49009,
	"./IconWarningOutline.tsx": 49009,
	"./IncognitoIcon": 11743,
	"./IncognitoIcon.js": 11743,
	"./InfoIconWithCircle": 87055,
	"./InfoIconWithCircle.js": 87055,
	"./IngredientAntipreferencesIcon": 36666,
	"./IngredientAntipreferencesIcon.js": 36666,
	"./ListIcon": 60390,
	"./ListIcon.js": 60390,
	"./MapMarkerIcon": 17882,
	"./MapMarkerIcon.js": 17882,
	"./MonitorIcon": 10092,
	"./MonitorIcon.js": 10092,
	"./NetworkIcon": 64294,
	"./NetworkIcon.js": 64294,
	"./NuddleIcon": 35115,
	"./NuddleIcon.js": 35115,
	"./NutIcon": 43724,
	"./NutIcon.js": 43724,
	"./OkIcon": 43236,
	"./OkIcon.js": 43236,
	"./PencilIcon": 57668,
	"./PencilIcon.js": 57668,
	"./PencilLightIcon": 69570,
	"./PencilLightIcon.js": 69570,
	"./PiggyBankIcon": 14183,
	"./PiggyBankIcon.js": 14183,
	"./PlusIcon": 9716,
	"./PlusIcon.js": 9716,
	"./PointerHandIcon": 9157,
	"./PointerHandIcon.js": 9157,
	"./PriceTagIcon": 84910,
	"./PriceTagIcon.js": 84910,
	"./PrinterIcon": 18213,
	"./PrinterIcon.js": 18213,
	"./PuzzleIcon": 28135,
	"./PuzzleIcon.js": 28135,
	"./QuestionCicrle": 76391,
	"./QuestionCicrle.js": 76391,
	"./RedoIcon": 96808,
	"./RedoIcon.js": 96808,
	"./SadShoppingBasketIcon": 30265,
	"./SadShoppingBasketIcon.js": 30265,
	"./SearchIcon": 45857,
	"./SearchIcon.js": 45857,
	"./SelectAllIcon": 38284,
	"./SelectAllIcon.js": 38284,
	"./ServerIcon": 28945,
	"./ServerIcon.js": 28945,
	"./ShareSquareIcon": 34907,
	"./ShareSquareIcon.js": 34907,
	"./ShoppingBagIcon": 83604,
	"./ShoppingBagIcon.js": 83604,
	"./ShoppingBasketIcon": 83051,
	"./ShoppingBasketIcon.js": 83051,
	"./SpinnerIcon": 34143,
	"./SpinnerIcon.js": 34143,
	"./SpinnerThirdIcon": 95260,
	"./SpinnerThirdIcon.js": 95260,
	"./StarIcon": 95636,
	"./StarIcon.js": 95636,
	"./StopIcon": 42515,
	"./StopIcon.js": 42515,
	"./StripeCardIcon": 21954,
	"./StripeCardIcon.js": 21954,
	"./TilesIcon": 95997,
	"./TilesIcon.js": 95997,
	"./TimesIcon": 90700,
	"./TimesIcon.js": 90700,
	"./TransferIcon": 24607,
	"./TransferIcon.js": 24607,
	"./UncheckedCheckbox": 82243,
	"./UncheckedCheckbox.js": 82243,
	"./UnselectAllIcon": 29547,
	"./UnselectAllIcon.js": 29547,
	"./WarningIcon": 9741,
	"./WarningIcon.js": 9741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 8242;
module.exports = webpackContext;